var render = function render(){var _vm=this,_c=_vm._self._c;return _c('star-rating',{attrs:{"rating":_vm.rating,"read-only":true,"star-size":22,"text-class":"hidden","active-color":"#fdcf6e","border-width":2,"border-color":"transparent","rounded-corners":true,"active-color":_vm.activeColor,"inactive-color":_vm.inactiveColor,"star-points":[
    23, 2, 14, 17, 0, 19, 10, 34, 7, 50, 23, 43, 38, 50, 36, 34, 46, 19, 31,
    17,
  ]}})
}
var staticRenderFns = []

export { render, staticRenderFns }